const sr = {
    unruly: "Neodržano",
    youCanOnlyEnterNumbers: "Samo brojevi",
    passwordAlreadyUsed: "Lozinka je već dodeljena operateru",
    operatorModification: "Izmena operatera",
    appVersion: "Verzija aplikacije: {{number}}",
    departures: "Polasci",
    forbidPage: "Zabrani stranice",
    forbiddenPages: "Zabranjene stranice",
    connectingPlate: "Povezivanje: {{plate}}; {{time}}",
    passengerTypeIsRequired: "Tip putnika je obavezan!",
    emailForTicket: "Email za kartu/e",
    emailForTicketIsRequired: "Email za kartu/e je obavezan!",
    saveAndGoToAllotments: "Sačuvaj i idi na alotman",
    extendTooltip: "Produži period važenja",
    return: "Povratak",
    jbkjs: "JBKJS",
    assignedCapacity: "Dodeljen kapacitet",
    allDataSuccessfullySaved: "Uspešno ste sačuvali sve podatke",
    bisCount: "Ukupno bis vozila",
    available: "Slobodno",
    reservationsList: "Lista rezervacija",
    tripSeatStatus : "Dodeljeni kapaciteti",
    editCapacity : "Izmena kapaciteta",
    rateCardName: "Naziv cenovnika",
    chooseReturnTrip: "Izaberite povratak",
    rfidCardAlreadyExists: "Već postoji povlastica sa ovim brojem",
    passengerNameIsRequired: "Ime putnika je obavezno",
    passengerLastNameIsRequired: "Prezime putnika je obavezno",
    realOperator: "Stvarni prevoznik",
    saveAndInsertNewTrip: "Sačuvaj i dodaj novi polazak",
    refundType: "Tip refundacije",
    makeReservation: "Napravi rezervaciju",
    emailAlreadyExists: "Mejl adresa je zauzeta",
    EMAIL_ALREADY_EXISTS: "Mejl adresa je zauzeta",
    firebaseUserDeletionFailed: "Brisanje nije uspelo",
    firebaseUserNotFound: "Nije pronađen korisnik na firebase po UID",
    cloneCarateristics: "Kloniraj sa karakteristikama",
    liquidationPreview: "Pregled likvidature",
    linkedTrips: "Povezani polasci",
    domesticTransport: "Međumesna",
    internationalTransport: "Međunarodna",
    busStation: "Autobuska stanica",
    amountInternational: "Iznos međunarodna",
    vatInternational: "Stopa međunarodna",
    refund: "Refundacija",
    entry: "Ulaz:",
    exit: "Izlaz:",
    recognizedVehicle: "<strong>{{type}}</strong> <strong>{{licensePlate}}</strong>.",
    autoConnectedText: "Za vozilo <strong>{{licensePlate}}</strong> je automatski zabeležen izlaz.",
    close: "Zatvori",
    testTicketText: "Ovo je testna karta",
    platformBusyness: "Zauzetost perona",
    systemCheck: "Provera sistema",
    ticketVerification: "Overa karte",
    vpfrCheck: "Provera VPFR-a",
    printerCheck: "Provera stampača",
    lastTicketCheck: "Štampanje poslednje karte",
    chooseOperator: "Izaberite prevoznika",
    fromRateCard: "Sa cenovnika",
    toRateCard: "Na cenovnik",
    printLogoOnInvoice: "Štampati logo na računu",
    printLogoOnTicket: "Štampati logo na karti",
    comments: "Komentari",
    checkboxOneWay: "U polasku",
    checkboxReturn: "U povratku",
    characteristics: "Karakteristike",
    maxLengthExceeded: "Maksimalno karaktera je: ",
    documentsObj: {
        success: "Potpuna dokumentcija",
        warning: "Dokumentacija nepotpuna",
        error: "Nema dokumenta"
    },
    documentationStatus: "Status dokumentacije",
    invoiceSettings: "Podešavanje računa",
    adjustAppearanceInvoice: "Prilagodi izgled svog računa",
    advertisingText: "Reklamni tekst",
    printTestInvoice: "Štampaj uzorak računa",
    errorActionsFetching: "Greška prilikom učitavanja akcija",
    privilegesList: "Lista tipova povlastica",
    addingNewPlatform: "Dodavanje novog perona",
    newPlatform: "Novi peron",
    platformNumber: "Broj perona",
    selectCarrier: "Izaberite prevoznika",
    number: "Broj",
    id: "ID",
    free: "Slobodno",
    reserved: "Rezervisano",
    writeMessage: "Napiši poruku",
    writeContentOfMessage: "Unesite sadržaj poruke...",
    forEmployers: "Zaposleni",
    atLeastOneTypeRequired: "Označit jedno ili više",
    forPassengers: "Putnici",
    returnDate: "Datum povratka",
    forOtpravnik: "Optravnici/objavljivači",
    forEveryone: "Za sve",
    platforms: "Peroni",
    platform: "Peron",
    noTripsOnDate: "Nema polaska za ovaj dan",
    forDate: "Za dan",
    moreDetails: "Više detalja",
    disabilityId: "Povlastica",
    choose: "Izaberite",
    enterNumber: "Unesite broj",
    operationalInterval: "Interval",
    editAllotment: "Izmena alotmana",
    carrierName: "Naziv prevoznika",
    carriers: "Prevoznici",
    home: "Početna",
    list: "Lista",
    createNew: "Napravi novog",
    type: "Tip",
    description: "Opis",
    insurance: "Osiguranje",
    carriersList: "Lista prevoznika",
    country: "Država",
    edit: "Ažuriraj",
    delete: "Obriši",
    success: "Uspešno",
    successFetching: "Uspešno očitani podaci",
    errorFetching: "Greška prilikom očitavanja podataka",
    errorChangingStatus: "Došlo je do greške prilikom promene statusa",
    lineList: "Lista linija",
    lines: "Linije",
    add: "Dodaj",
    remove: "Ukloni",
    dateRangesOverlap: "Datumi se preklapaju",
    preview: "Pregled",
    giveUp: "Odustani",
    cancel: "Poništi",
    youNeedToSelectBeforeEdit: "Niste onzačili red koji želite izmeniti",
    youNeedToSelectBeforePreview: "Niste onzačili red koji želite pregledati",
    rowsPerPage: "Redova po strani",
    isActiveDiscount: "Popust akitvan",
    theDateUntilWhichTheDepartureIsCancelled: "Otkazivanje polaska za određen period po određenim karakteristikama",
    total: "Ukupno",
    held: "Održano",
    left: "Preostalo",
    shownRows: "Prikaz redova",
    ofTotal: "od ukupno",
    goBack: "Nazad",
    successAdded: "Uspešno ste dodali",
    maxDaysOfReturnDate: "Maksimalno dana za povratak",
    reducedSpacing: "Smanjen prored",
    errorFindingCarrier: "Greška, prevoznik nije pronađen",
    newCarrier: "Nov prevoznik",
    departuresArrivalsStatistic: "Statistika održanih polazaka/dolazaka",
    requiresReturnDate: "Ima datum povratka",
    errorOnServer: "Greška na serveru",
    duplicateVehicle: "Izabrali ste ista vozila",
    duplicatePlatform: "Izabrali ste iste perone",
    drivingDays: "Dani održavnja",
    statusModification: "Promena statusa ili brisanje",
    areYouSureYouWantTo: "Da li ste sigurni da",
    doThisAction: "uradite ovu akciju",
    activate: "Aktiviraj",
    optional: "Opciono",
    onlyNumbers: "Samo brojevi",
    isNotActive: "Neaktivno",
    departuresArrivals: "Polasci/Dolasci",
    fillOutTheTrafficLog: "Popuni saobraćajni denvnik",
    carrier: "Prevoznik",
    allotmentList: "Lista alotmana",
    allotments: "Alotmani",
    discountsList: "Lista popusta",
    occupied: "Zauzeto",
    showSalesBreakdown: "Prikaži prodaju po lokaciji",
    noSalesData: "Nema podataka o prodaji",
    salesLocation: "Prodajno mesto",
    locationType: "Tip",
    internalSale: "Interna",
    externalSale: "Eksterna",
    oneWay: "Jedan smer",
    returnTicket: "Povratna",
    selected: "Izabrano",
    carrierDocumentation: "Dokumenti prevoznika",
    itinerary: "Itinerer",
    documents: "Dokumenti",
    submit: "Potvrdi",
    departure: "Polasci",
    permission: "Dozvola",
    contract: "Ugovor",
    discounts: "Popusti",
    discount: "Popust",
    discountReturn: "Popust povratak",
    name: "Naziv",
    status: "Status",
    addDiscount: "Dodavanje popusta",
    numberOfSeats: "Ukupno sedišta",
    numberOfSeat: "Broj sedišta",
    newDiscount: "Nov popust",
    onlyDigitNumbers: "Možete uneti samo brojeve",
    onlyDigitChars: "Možete uneti samo slova",
    allowedNameChars: "Dozvoljena su slova, brojevi, razmak, tačka, crtica i apostrof",
    fieldIsRequired: "Obavezno polje",
    relations: "Relacije",
    enterName: "Unesite naziv",
    scheduleAndDep: "Red vožnje i polasci",
    departuresFor: "Polasci za",
    loadingText: "Učitavanje...",
    enterAtLeastOneCharacter: "Unesite bar jedan karakter...",
    vehicles: "Vozila",
    departureStatus: "Status polazaka",
    plateNumber: "Reg. oznaka",
    capacity: "Kapacitet",
    allotmentUsers: "Korisnici alotmana:",
    driveParkList: "Lista voznog parka",
    minNumberOfSeats: "Minimalni broj sedišta",
    clear: "Očisti",
    line: "Linija",
    dateFrom: "Datum od",
    dateTo: "Datum do",
    priceListName: "Naziv cenovnika",
    depFrom: "Polazak",
    departureEditTitle: "Izmena polaska",
    departureEdit: "Izmeni polazak",
    cooperator: "Kooperator",
    forLine: "Za liniju",
    startStation: "Početna stanica",
    endStation: "Krajnja stanica",
    numerated: "Numerisana",
    lineName: "Naziv linije",
    newAllotment: "Dodavanje alotmana",
    allotment: "Alotman",
    refresh: "Osveži",
    fromSeat: "Od broja sedišta",
    toSeat: "do sedišta",
    numberedSeats: "Numerisana sedišta",
    noNumberedSeats: "Nenumerisana sedišta",
    splitPeriod: "Sa skraćivanjem perioda",
    dontSplitPeriod: "Bez skraćivanja perioda",
    numberOfFreeSeats: "Broj dodeljenih alotmana",
    vehicleAlreadyExists: "Vozilo već postoji pod ovom registracionom oznakom",
    willBeSaved: "Upisuje se u saobraćajni dnevnik",
    reservations: "Rezervacije",
    reservationsPreview: "Pregled rezervacija",
    errorOnEdit: "Došlo je do greške prilikom izmene",
    maximumDays: "Maksimalan broj dana",
    save: "Sačuvaj",
    disableOnlineSale: "Isključi online prodaju",
    saleOnApps: "Prodaja preko aplikacija",
    enterAllField: "Popunite sva polja sa *",
    editVehicle: "Izmena vozila",
    vehicle: "Vozilo",
    carrierNotFound: "Prevoznik nije pronađen",
    editDiscount: "Izmena popusta",
    addingVehicle: "Dodavanje vozila",
    privileges: "Povlastice",
    addingNewVehicle: "Dodavanje novog vozila",
    editPrivileges: "Izmena povlasitce",
    privilege: "Povlastica",
    expired: "Istekao rok važenja",
    issuePlace: "Mesto izdavanja",
    documentType: "Tip dokumenta",
    invalid: "Invalidnost",
    privilegePass: "Broj povlastice",
    issueDate: "Datum izdavanja",
    instantEditAllotment: "Instant alotmani",
    assignedAllotment: "Dodeljeni alotman",
    validityPeriod: "Period važenja",
    operationalDays: "Dani održavanja",
    archive: "Arhivirani",
    date: "Datum",
    maxSeats: "Ukupno sedišta",
    instant: "Instant",
    durationTime: "Rok važenja",
    find: "Pronađi",
    depStation: "Polazna stanica",
    arrStation: "Krajnja stanica",
    priceTitle: "Cenovnik",
    priceList: "Lista cenovnika",
    licenceNumber: "Broj licence",
    holidays: "Praznici",
    tripTime: "Vreme polaska sa stanice",
    addNewHolidaysTitle: "Dodavanje praznika",
    newHolidaysList: "Nov praznik",
    holidayName: "Naziv praznika",
    addNewPriceTitle: "Dodavanje novog cenovnika",
    newPriceList: "Nov cenovnik",
    addingStationsRate: "Dodavanje stanice po cenovnika",
    newStation: "Nova stanica",
    isAvailableOnline: "Dostupno za online prodaju",
    isActive: "Aktivan",
    bisVehicle: "Bis vozilo",
    level: "Stepen",
    disabilitiesList: "Lista",
    disability: "Invalidnost",
    newDisability: "Nova invalidnost",
    absoluteRelative: "Absolutna - relativna",
    amount: "Iznos",
    actionsList: "Lista akcija",
    newAction: "Nova akcija",
    addingNewAction: "Dodavanje nove akcije",
    absolute: "Apsolutna",
    relative: "Relativna",
    action: "Akcija",
    actions: "Akcije",
    editAction: "Izmena akcije",
    actionsValueList: "Lista vrednosti akcija",
    actionsValue: "Vrednosti akcija",
    vat: "PDV",
    trafficType: "Vrsta saobraćaja",
    addingNewValueAction: "Dodavanje vrednosti akcije",
    actionValueList: "Lista vrednosti akcija",
    newValueAction: "Nova vrednost akcije",
    pib: "PIB",
    jmbg: "Matični broj",
    email: "Mejl",
    webAddress: "Web adresa",
    phone: "Telefon",
    city: "Grad",
    address: "Adresa",
    bankAccount: "Žiro račun",
    salesContact: "Kontakt prodaje",
    printText: "Tekst za štampu",
    subPrivilege: "Pod privilegija",
    fillOutAllFields: "Popunite sva polja",
    createNewCarrier: "Dodavanje novog prevoznika",
    priceListEdit: "Lista cenovnika",
    stationByRateCard: "Stanice po cenovniku",
    rateCard: "Cenovnik",
    priceOneDirection: "Cena (jedan smer)",
    priceReturn: "Cena (povratak)",
    priceMonthly: "Cena (ceo mesec)",
    priceDaily: "Cena (dnevna)",
    departureTime: "Polazak",
    addingNewLine: "Dodavanje nove linije",
    tripExceptions: "Izuzeci stanica na polascima",
    loading: "Učitavanje...",
    peronizationRate: "Cenovnik peronizacije",
    peronization: "Peronizacija",
    publicationText: "Tekst za objavljivanje",
    markIfActive: "Vozilo je aktivno",
    editActionValue: "Izmena vrednosti akcije",
    choosePrivilegeDiscount: "Izaberite tip privilegije",
    chooseDiscounts: "Izaberi popuste",
    newLine: "Nova linija",
    borderName: "Naziv graničnog prelaza",
    carrierPIB: "PIB prevoznika",
    findStation: "Pronađi stanicu",
    insuranceOffer: "Ponuda osiguranja na prodaji",
    active: "Aktivna",
    scheduleAndDepartures: "Red vožnje i polasci",
    departuresList: "Lista polazaka",
    exportCSV: "Izvezi CSV",
    chooseRateCard: "Izaberi cenovnik",
    addingNewDeparture: "Dodavanje novog polaska",
    newDeparture: "Nov polazak",
    surname: "Prezime",
    newVehicle: "Novo vozilo",
    onlyOneDiscountAllowed: "Samo jedan vid popusta je dozvoljen",
    copy: "Kopiraj",
    trip: "Polazak",
    all: "Svi",
    search: "Pretraži",
    user: "Korisnik",
    role: "Uloga",
    listOfOperators: "Lista zaposlenih",
    operators: "operateri",
    inactive: "Pasivan",
    newOperator: "Dodaj operatera",
    creatingOperator: "Dodavanje zaposlenog",
    username: "Korisničko ime",
    stationName: "Naziv stanice",
    clonePrices: "Kloniraj cene",
    password: "Lozinka",
    deactivate: "Obriši",
    comment: "Komentar",
    newRateCardName: "Novi naziv cenovnika",
    newRateCard: "Novi cenovnik",
    newLineName: "Novi naziv linije",
    cloneInverseLine: "Kloniraj inverznu liniju",
    cloneLine: "Kloniraj liniju",
    lineCloning: "Kloniranje linije",
    clonePreview: "Itinerer kopije",
    clonePreviewLoading: "Računanje itinerera…",
    clonePreviewEmpty: "Itinerer nije izračunat",
    clonePreviewRates: "Cena koje se kopiraju",
    clonePreviewOverwriteWarning: "Postojeće cene na odredišnom cenovniku za ove stanice biće pregažene",
    inverseSuggestionApplied: "Predložene su obrnute vrednosti — proveri ih i dopuni vreme polaska",
    inverseDepartureTimeHint: "Vreme polaska povratne linije nije moguće izračunati — unesi ga ručno",
    fromRateCardRequiredWithTarget: "Izaberi cenovnik iz kog se cene kopiraju",
    stationOrderColumn: "Rb.",
    returnFromSpot: "Povratak iz mesta",
    doYouWantToCloneLine: "Želite da klonirate liniju",
    //calemName: "Naziv kalem linije",
    acceptsETicket: "Prihvata e-kartu",
    periodName: "Naziv praznika",
    dateOverlap: "Datum se preklapa sa nekom od prethodno unetih",
    uniqueNameError: "Ime praznika je zauzeto",
    choosePeriod: "Praznici/Izuzeci",
    addPeronization: "Dodaj peronizaciju",
    creatingPeronization: "Dodavanje peronizacije",
    dashboard: "Početna",
    existingRateCard: "Postojeći cenovnik",
    addParking: "Dodaj parking",
    operator: "Operater",
    additionalRevenueDetailedReport: "Izveštaj svih staničnih usluga detaljno",
    carrierReportTickets: "Izveštaj o prodatim kartama",
    whiteListReport: "Bela lista - izveštaj",
    isOneWayOnly: "Samo jedan smer",
    isReturnTicketOnly: "Samo porvatna",
    isForAllLines: "Za sve linije",
    isRoundPrice: "Zaokruživanje cene",
    importantInformation: "Informacije za unos podataka",
    arrivalTime: "Dolazak",
    youMustSelectAtLeastOneDayOfTheWeek: "Proverite da li ste izabrali dan u nedelji koji se nalazi u opsegu datuma od i do",
    addArrivalsDepartures: "Dodaj polazak/dolazak",
    onlineSale: "Online prodaja",
    applyDiscountOneWay: "Za jedan smer",
    applyDiscountReturnTicket: "Za povratak",
    applyRoundPrice: "Zaokružena cena",
    applyToAllTrips: "Na svim polascima",
    documentValidation: "Verifikacija dokumenta",
    phoneNumber: "Broj telefona",
    hasException: "Izuzeci",
    isMgsi: "MGSI",
    noOptions: "Nema rezultata",
    yes: "Da",
    no: "Ne",
    rateCards: "Cenovnici",
    monday: "Ponedeljak",
    tuesday: "Utorak",
    wednesday: "Sreda",
    thursday: "Četvrtak",
    friday: "Petak",
    saturday: "Subota",
    sunday: "Nedelja",
    successEdited: "Uspešno ste izmenili",
    cancelledTripsHistoryList: "Istorija - otkazani polasci ",
    ratesHistoryList: "Istorija - popusti",
    tripExceptionHistoryList: "Istorija - izuzeci polazaka",
    vehicleSuccessfullyDeleted: "Uspešno ste obrisali vozilo.",
    vehicleInUseForTrip: "Nije moguće brisanje, vozilo se koristi.",
    serverErrorOccurred: "Trenutno nije moguće izvršiti ovaj zahtev.",
    editTooltip: "Ažuriraj",
    attachRateCardTooltip: "Dodaj cenovnik",
    insertTooltip: "Dodaj",
    instantTooltip: "Instant dodavanje",
    liquidationTooltip: "Uradi likvidaciju",
    infoForStationsUsage: "Informacija o upotrebi stanice",
    editRouteTooltip: "Ažuriraj redosled stanica",
    closeTooltip: "Zatvori",
    documentPreviewTooltip: "Dokumentacija",
    deactivateTooltip: "Deaktiviraj",
    issuedFor: "Izdato za prevoznika",
    actionName: "Naziv akcije",
    licenceName: "Naziv licence",
    activateTooltip: "Aktiviraj",
    activateTooltipMGSI: "Aktiviraj i uklni komentar MGSI",
    ticketTypeName: "Naziv popusta",
    deleteTooltip: "Obriši",
    deleteTooltipMGSI: "Obriši po MGSI",
    cloneTooltip: "Kloniraj",
    previewTooltip: "Pregledaj",
    statusChangeTooltip: "Promeni status",
    deleteRelatedTooltip: "Obriši povezane",
    statusSuccessfullyChanged: "Uspešno ste promenili status",
    ticketTypeSuccessfullyDeleted: "Uspešno ste obrisali popust",
    ticketTypeInUse: "Nije moguće brisanje, popust se koristi",
    invalidVehicleId: "Vozilo nije pronađeno",
    invalidOperatorId: "Operater nije pronađen",
    invalidTicketTypeId: "Popust nije pronađen",
    rateCardSuccessfullyDeleted: "Uspešno ste obrisali cenovnik.",
    rateCardInUse: "Nije moguće brisanje, cenovnik se koristi.",
    rateAlreadyInUse: "Nije moguće brisanje, cena se koristi.",
    periodSuccessfullyDeleted: "Uspešno ste obrisali praznik.",
    periodAlreadyInUse: "Nije moguće brisanje, praznik se koristi.",
    periodDateSuccessfullyDeleted: "Uspešno ste obrisali period za izabrani praznik.",
    dateFromIsHigherThenDateTo: "Datum od ne može biti već ili jedank od datuma do",
    rateSuccessfullyDeleted: "Uspešno ste obrisali cenu.",
    linesTooltip: "Linije na kojima se primenjuje izuzetak sa popustom.",
    exception: "Izuzetak",
    actionTypeSuccessfullyDeleted: "Uspešno ste obrisali akciju.",
    dateToSuccessfullyChanged: "Uspešno ste promenili datum važenja.",
    stationSuccessfullyDeleted: "Uspešno ste obrisali stanicu.",
    stationInUse: "Nije moguće brisanje, stanica se koristi.",
    stationWithNameIsAlreadyCreated: "Stanica sa ovim nazivom već postoji u bazi na izabranoj lokaciji.",
    dataIntegrityViolation: "Nije moguće dodavanje duplikata.",
    locationWithNameIsAlreadyCreated: "Lokacija sa ovim nazivom već postoji u bazi.",
    locationSuccessfullyDeleted: "Uspešno ste obrisali lokaciju.",
    lineSuccessfullyDeleted: "Uspešno ste obrisali liniju, njene polaske i alotmane.",
    locationInUse: "Nije moguće brisanje, lokacija se koristi.",
    lineInUse: "Nije moguće brisanje, linija ima pordate karte.",
    deleteTooltipLine: "Brisanjem linije, brišu se i polasci i alotmani.",
    confirmDeleteTitle: "Potvrda brisanja",
    confirmDeleteContent: "Da li ste sigurni da želite da obrišete ovaj unos?",
    showScheme: "Prikaži matricu",
    hideScheme: "Sakrij matricu",
    rfidCardSuccessfullyDeleted: "Uspešno ste obrisali povlasticu.",
    operatorInUse: "Nije moguće brisanje, prevoznik se koristi.",
    operatorSuccessfullyDeleted: "Uspešno ste obrisali prevoznika.",
    saveAndGoToDeparture: "Sačuvaj i idi na polazak",
    licensePlateExists: "Već postoji vozilo sa ovom reg. oznakom",
    characterCount: "Maksimalni broj karaktera",
    prohibitedCyrillic: "Nije dozvoljena ćirilica",
    distanceInKmCannotBeNull: "Morate prvo definisati itinerer",
    instantTripTitle: "Dodavanje polaska za period",
    pricePreviewTooltip: "Pregled cenovnika",
    errors: {
        name: "Naziv",
        discountName: "Unesite naziv popusta",
        discountCarrier: "Unesite naziv prevoznika",
        discountAmount: "Morate uneti visinu popusta za polazak u procentima ili apsolutnu vrednost",
        discountAmountReturn: "Morate uneti visinu popusta za povratak u procentima ili apsolutnu vrednost",
        delete: "Brisanje nije moguće",
        dateOverlap: "Datum se preklapa sa nekom od prethodno unetih akcija!",
    },
    validation: {
        maxNumOfCharacters: "Maksimalni broj karaktera je ",
        minNumOfCharacters: "Minimalni broj karaktera je ",
        phone: "Telefon mora imati od 8 do 15 brojeva"
    },
    journeyDate: "Datum polaska",
    start: "Početak",
    end: "Kraj",
    tripReservation: "Rezervacija polaska",
    passengerDetails: "Podaci putnika",
    numberOfPassengers: "Broj putnika",
    passenger: "Putnik",
    registeredPassengerWithPrivilege: "Registrovan sa povlasticom",
    seatNumber: "Broj sedećeg mesta",
    firstName: "Ime putnika",
    lastName: "Prezime putnika",
    clientIdentity: "Uključi/isključi smer karte",
    cardNumber: "Broj karte",
    selectPrivilegeDiscount: "Tip povlastice",
    changeProductOnBillPrice: "Unesite novu cenu",
    newPrice: "Nova cena",
    saveInDatabase: "Sačuvaj u bazi",
    changeProductOnBillName: "Sačuvaj u bazi",
    changeProductOnBillDiscount: "Unesite popust",
    productName: "Naziv proizvoda/usluge",
    trainingMode: "Obuka mod",
    turnOnOrOffTrainingMode: "Uključi / isključi obuka mod",
    allotmentOnlyHaveOneDayDiff: "Ovaj alotman ima jedan dan razlike i zato nije moguće koristiti ga za kreiranje instant alotmana",
    departureTimeFromAlDefinedStation: "Polazak sa definisane stanice",
    definedAlStation: "Definisana stanica",
    allotmentAssignedList: "Lista dodeljenih alotmana",
    allotmentCurrentList: "Lista dostupnih alotmana",
    allotmentCurrent: "Dostupnih alotmani",
    commentsList: "Lista komentara",
    selectedDay: "Odabrani dan je",
    departureDate: "Datum polaska",
    dayNumberInYear: "redni dan u godini",
    departureTimeFromStation: "Polazak sa izabrane stanice",
    givenAllotments: "Dodeljeno alotmana",
    soldServicesReport: "Izveštaj o prodatim uslugama",
    arrPrice: "Cena prijema",
    depPrice: "Cena otpreme",
    even: "paran",
    odd: "neparan",
    ticketNumber: "Broj karte",
    exceptionList: "Lista izuzetaka",
    searchHolidays: "Izuzeci",
    stationSearchType: "Tip pretrage stanice",
    stationForFiltering: "Stanica za pretragu",
    whoSee: "Ko vidi",
    filterSettings: "Podešavanje filtera",
    stationTimes: "Vremena polaska",
    cancelAll: "Poništi sve",
    selectAll: "Označi sve",
    availableAllotments: "Dostupni alotmani",
    tripDateIsMandatory: "Datum polaska je obavezan",
    tripIdIsMandatory: "Polazak je obavezan",
    showOnlyWithCurrentPriceLists: "Prikaži rezultate samo sa aktivnim cenovnikom",
    allotmentType: {
        all: "Svi",
        predefined: "Predefinisani",
        instant: "Instant",
        archived: "Arhivirani",
        current: "Trenutni"
    },
    stationFilter: {
        contain: "Sadrži stanicu",
        departure: "Početna stanica",
        arrival: "Krajnja stanica"
    },
    transactionType: {
        sale: "Prodaja",
        refund: "Refundacija"
    },
    invoiceType: {
        normal: "Promet prodaja",
        proforma: "Predračun",
        copy: "Kopija",
        training: "Obuka",
        advance: "Avans",
    },
    itemName: "Naziv",
    ticketId: "Broj karte",
    outboundTicketId: "Broj povratne",
    typeName: "Vrsta karte",
    departureStationName: "Polazna",
    arrivalStationName: "Poslednja",
    vehiclePlateNumber: "Vozilo",
    seat: "Sedište",
    cashier: "Kasir",
    invoiceNumber: "Broj računa",
    paymentType: "Načini plaćanja",
    operationInterval: "Karakteristike",
    departuresLinkedList: "Povezani polasci",
    fiscalize: "Fiskalizuj",
    totalAmountForPay: "Ukupan iznos za uplatu",
    seatsSelection: "Biranje sedišta",
    loadingSeats: "Očitavanje sedišta...",
    ongoingProcess: "Proces je u toku, molimo za strpljenje...",
    selectVehicle: "Izaberi vozilo",
    projectUpdates: "Izdanja i poboljšanj",

    // Validity Periods
    validityPeriods: "Periodi važenja",
    addPeriod: "Dodaj period",
    removePeriod: "Ukloni period",
    noValidityPeriods: "Nema definisanih perioda važenja. Popust će važiti uvek.",
    period: "Period",
    validDays: "Važi",
    oddDays: "Neparni dani",
    evenDays: "Parni dani",
    always: "Uvek",
    periodsCount: "period(a)",

    // Validation messages
    dateFromRequired: "Datum od je obavezan",
    dateToRequired: "Datum do je obavezan",
    dateToAfterFrom: "Datum do mora biti nakon datuma od",
    intervalRequired: "Operativni interval je obavezan",
    departureTimeInvalid: "Vreme polaska mora biti između 00:00 i 23:59",
};

export default sr;
